import { SET_BRANCH, SET_BRANCHES } from "../../constants/branchConstants";

export const setBranch = (branch) => {
  return {
    type: SET_BRANCH,
    branch,
  };
};

export const setBranches = (branches, filtered = false) => {
  return {
    type: SET_BRANCHES,
    branches,
    filtered,
  };
};
